"use strict";

CompanyAdvancedSearchDirective.$inject = [
  "$timeout",
  "$stateParams",
  "$state",
  "$filter",
  "$translate",
  "$rootScope",
  "CompanyInfoService",
  "CurrentUserService"
];
function CompanyAdvancedSearchDirective(
  $timeout,
  $stateParams,
  $state,
  $filter,
  $translate,
  $rootScope,
  CompanyInfoService,
  CurrentUserService
) {
  return {
    replace: true,
    restrict: "AE",
    scope: {
      categories: "=asCategories",
      customerPortals: "=asGroups",
      types: "=asTypes",
      priorities: "=asPriorities",
      tags: "=asTags",
      toggleMenuSearch: "=asToggle"
    },
    templateUrl: "partials/company/publications/advanced-search.html",
    link: function($scope) {
      $scope.params = $stateParams;
      $scope.years = [];
      for(var y=2010; y<2030; y++){
        $scope.years.push(y.toString())
      }

      $scope.months = [];
      for(var m=1; m<12; m++){
        $scope.months.push(m.toString())
      }

      $scope.$on("advancedSearchSidebarToggle", function() {
        $scope.advancedSearchSidebarOpen = !$scope.advancedSearchSidebarOpen;
      });

      $scope.toggleShowAll = function() {
        $rootScope.toggleShowAllPublications = !$rootScope.toggleShowAllPublications;
      }

      $scope.publicationQuery = {
        qType: "GENERAL",
        tags: ""
      };

      if ($stateParams.openSearchSidebar) {
        $scope.advancedSearchSidebarOpen = true;
      }

      if ($stateParams.tags) {
        $scope.publicationQuery.tags = $stateParams.tags;
      }

      CompanyInfoService.get({
        companyId: $stateParams.companyId
      }).$promise.then(function(resp) {
        $scope.info = resp;
      });
      CurrentUserService.getPermissions($stateParams.companyId).then(function(
        resp
      ) {
        $scope.currentUserPermissions = resp;
      });
      $scope.publicationQuery.q = $stateParams.q;
      $scope.selectedPublicationType = $stateParams.type || null;
      $scope.selectedOrderBy = $stateParams.orderby || "created";
      $scope.selectedYear = $stateParams.year || "";
      $scope.selectedMonth = $stateParams.month || "";
      $scope.publicationQuery.qType = $stateParams.qType || "GENERAL";
      $scope.publicationQuery.qTypeObject = $state.params.qTypeObject || "OBJECT";
      $scope.selectedPriority = null;
      $scope.publicationQuery.type = $state.params.type;

      if ($scope.publicationQuery.qT === "CUSTOMER") {
        $scope.placeholderSearch = $translate.instant("search-customer");
      } else {
        if ($scope.publicationQuery.qT === "PRODUCT") {
          $scope.placeholderSearch = $translate.instant("search-products");
        } else {
          if ($scope.publicationQuery.qT === "ARCHIVED") {
            $scope.placeholderSearch = $translate.instant("search-archive");
          } else {
            $scope.placeholderSearch = $translate.instant("search-object");
          }
        }
      }

      var startDate = Date.parse($stateParams.from);
      var endDate = Date.parse($stateParams.to);

      $scope.filterDataSpan = {
        from: startDate ? new Date(startDate) : null,
        to: endDate ? new Date(endDate) : null
      };

      $scope.filterTags = $stateParams.tags;

      for (var i = 0; i < $scope.categories.length; i++) {
        if ($scope.categories[i].id === $stateParams.categoryId) {
          $scope.selectedCategory = $scope.categories[i];
        }
      }

      for (i = 0; i < $scope.customerPortals.length; i++) {
        if ($scope.customerPortals[i].id === $stateParams.groupId) {
          $scope.selectedCustomerPortal = $scope.customerPortals[i];
        }
      }

      for (i = 0; i < $scope.priorities.length; i++) {
        if ($scope.priorities[i].id === $stateParams.priorityId) {
          $scope.selectedPriority = $scope.priorities[i];
        }
      }

      $scope.$watch("toggleMenuSearch", function(toggle, oldToggle) {
        if (toggle !== oldToggle) {
          $scope.toggleMenuSearch = toggle;
        }
      });

      var searchTimeout;
      $scope.filterPublications = function() {
        $rootScope.toggleShowAllPublications = false;
        var q = angular.copy($scope.publicationQuery);
        q.openSearchSidebar = null;

        if ($scope.filterDataSpan.from !== "") {
          q.from = $filter("date")($scope.filterDataSpan.from, "yyyy-MM-dd");
        }

        if ($scope.filterDataSpan.to !== "") {
          q.to = $filter("date")($scope.filterDataSpan.to, "yyyy-MM-dd");
        }

        if ($scope.selectedYear !== "") {
          q.year = $scope.selectedYear;
        }
        
        if ($scope.selectedMonth !== "") {
          q.month = $scope.selectedMonth;
        }

        if ($scope.publicationQuery.qTypeObject === "OBJECT") {
          $state.go("root.company.publications-list", q);
        } else {
          q.companyId = $stateParams.companyId;
          q.archived = $scope.filterText;
          $state.go("root.company.publications-list", q);
        }

        $scope.advancedSearchSidebarOpen = false;
      };

      $scope.changeSelectedYear = function(year) {
          $scope.selectedYear = year;
      };

      $scope.changeSelectedMonth = function(month) {
          $scope.selectedMonth = month;
      };

      $scope.filterCategory = function(cat) {
        $scope.publicationQuery.categoryId = cat.id;
      };

      $scope.filterCustomerPortal = function(portal) {
        $scope.publicationQuery.groupId = portal.id;
      };

      $scope.filterPublicationType = function(pubType) {
        $scope.publicationQuery.type = pubType;
      };

      $scope.filterDate = function(dataSpan) {
        if (dataSpan.from !== '') {
          $scope.publicationQuery.from = $filter('date')(dataSpan.from, "yyyy-MM-dd");
        }
        if (dataSpan.to !== '') {
          $scope.publicationQuery.to = $filter('date')(dataSpan.to, "yyyy-MM-dd");
        }
      };

      $scope.filterByCreatedOrUpdated = function(v) {
        $scope.publicationQuery.orderby = v;
      };

      $scope.filterByqTypeObject = function(data) {
        if (data === "CUSTOMER") {
          $scope.placeholderSearch = $translate.instant("search-customer");
        } else {
          if (data === "PRODUCT") {
            $scope.placeholderSearch = $translate.instant("search-products");
          } else {
            if (data === "ARCHIVED") {
              $scope.placeholderSearch = $translate.instant("search-archive");
            } else {
              $scope.placeholderSearch = $translate.instant("search-object");
            }
          }
        }
        $scope.publicationQuery.qTypeObject = data;
      };

      $scope.filterByText = function(data) {
        $scope.publicationQuery.q = data;
      };

      $scope.filterStatus = function(priority) {
        $scope.publicationQuery.priorityId = priority.id;
      };

      $scope.filterTag = function(tag) {
        if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
          $scope.publicationQuery.tags.push(tag);
        } else {
          $scope.publicationQuery.tags.splice(
            $scope.publicationQuery.tags.indexOf(tag),
            1
          );
        }
      };
    }
  };
}

angular
  .module("dokiv")
  .directive("companyAdvancedSearch", CompanyAdvancedSearchDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyAdvancedSearchDirective.js
// module id = 309
// module chunks = 0